import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { usePersistantState, UUID } from '@umanforge/common';

import { KEY } from 'constants/local_storage_key.constant';
import VisualisationEventManager from 'features/visualisation_event_manager/components/visualisationEventManager.component';


function VisualisationEventManagerView() {

  const navigate = useNavigate();

  //-------------- useState ---------------\\
  const [ sectorId ] = usePersistantState<UUID | undefined>( KEY.SELECTED_SECTOR_ID, undefined );
  const [ isFirstRender, setIsFirstRender ] = useState( true );


  //-------------- useEffect --------------\\
  useEffect( () => {
    setIsFirstRender( false );
  }, [] );

  useEffect( () => {
    if ( !isFirstRender && sectorId == null ) {
      navigate( '/Home' );
    }
  }, [ isFirstRender ] );


  //---------------- Front ----------------\\
  return (
    <>
      {
        ( !isFirstRender && sectorId != null ) && <VisualisationEventManager/>
      }
    </>
  );
}

export default VisualisationEventManagerView;
